import React, { useEffect, useState } from "react";
import { Card, CardBody, Row, Col, Badge, Spinner } from "reactstrap";
import { useParams } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
// import { getLeadDetailsApi, createLeadViewHistoryApi, updateLeadStageApi, } from "../../apiServices/leadServices";
import {updateLeadStageApi } from "../../apiServices/leadServices";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import useLeads from "../../Hooks/useLeads";
import useStages from "../../Hooks/useStages";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, } from "reactstrap";

const REMARK_OPTIONS = [
  { label: "Default", value: "Default" },
  { label: "Broker", value: "Broker" },
  { label: "Seller", value: "Seller" },
  { label: "Property RM", value: "Property RM" },
  { label: "Buyer", value: "Buyer" },
  { label: "Investor", value: "Investor" },
  { label: "Channel Partner", value: "Channel Partner" },
  { label: "Tenant", value: "Tenant" },
  { label: "Other", value: "Other" },
];

const LeadDetails = () => {
  const { source, leadId } = useParams();
  const [stageModal,setStageModal]=useState(false);
  const [selectedStage,setSelectedStage]=useState("");
  const [comment,setComment]=useState("");
  const [remarkModal, setRemarkModal] = useState(false);
  const [selectedRemark, setSelectedRemark] = useState("");
  const [updatingRemark, setUpdatingRemark] = useState(false);
  const [activityPage,setActivityPage]=useState(1);
  const [isLeadDataUnlocked,setIsLeadDataUnlocked]=useState(false);
  const [phoneUnlocked,setPhoneUnlocked]=useState(false);
  const [emailUnlocked,setEmailUnlocked]=useState(false);
  const { leadDetails, activities, activityPagination, activityLoading,loading, fetchLeadDetails,createLeadActivityLog, fetchLeadActivity, updateLeadStage, updateLeadRemark, createLeadViewHistory, }=useLeads();
  const [contactLoading, setContactLoading] = useState("");

  const sourceConfig = {
    facebook: {
      icon: "mdi mdi-facebook",
      color: "info",
      label: "Facebook Lead",
    },
    google: {
      icon: "mdi mdi-google",
      color: "danger",
      label: "Google Lead",
    },
  };

  const currentSource = sourceConfig[source] || {
    icon: "mdi mdi-database",
    color: "secondary",
    label: "Unknown Source",
  };

  const maskPhone=(phone="")=>{
    if(!phone) return "-";
    return `${phone.slice(0,3)}*****${phone.slice(-3)}`;
  };
  const maskEmail=(email="")=>{
    if(!email) return "-";
    const [name,domain]=email.split("@");
    return `${name.slice(0,3)}*****@${domain}`;
  };
  const { stages }=useStages({
    limit:1000,
  });
  useEffect(()=>{
    if(!leadId || !source) return;

    fetchLeadDetails(source, leadId);
    createLeadViewHistory(source, leadId);

  },[leadId, source]);

  useEffect(()=>{
    if(!leadId) return;

    fetchLeadActivity(
       source,leadId,
      {
        page:activityPage,
        limit:10,
      }
    );

  },[leadId,activityPage]);
  const handleCallLead = async () => {
    try {
      setContactLoading("call");

      await createLeadActivityLog(source,leadId, {
        action: "call_initiated",
      });

      await fetchLeadActivity(source,leadId, {
        page: activityPage,
        limit: 10,
      });

      window.location.href = `tel:${leadDetails?.phone}`;
    } finally {
      setContactLoading("");
    }
  };

  const handleWhatsappLead = async () => {
    try {
      setContactLoading("whatsapp");

      await createLeadActivityLog( source,leadId, {
        action: "whatsapp_initiated",
      });

      await fetchLeadActivity( source,leadId, {
        page: activityPage,
        limit: 10,
      });

      const phone = leadDetails?.phone?.replace(/\D/g, "");

      window.open(`https://wa.me/${phone}`, "_blank");
    } finally {
      setContactLoading("");
    }
  };
  return (
    <div className="page-content">
      <Breadcrumbs title="Leads" breadcrumbItem="Lead Details" />

      <Card className="shadow-sm border-0">
        <CardBody className="p-4">
          {loading ? (
            <div className="text-center py-5">
              <Spinner />
            </div>
          ) : !leadDetails ? (
            <div className="text-center py-5">No Lead Found</div>
          ) : (
            <>
              {leadDetails?.isArchived && (
                <div className="alert alert-warning border border-warning shadow-sm rounded-3 p-3 mb-4 d-flex align-items-center justify-content-between flex-wrap gap-2">
                  <div className="d-flex align-items-center gap-2">
                    <i className="mdi mdi-archive-lock-outline text-warning" style={{ fontSize: "28px" }} />
                    <div>
                      <h6 className="mb-1 fw-bold text-dark">📦 Archived Lead (Activities & Editing Disabled)</h6>
                      <small className="text-muted">This lead is archived. Stage updates, remark edits, calling, WhatsApp, and activity logging are disabled on archived leads. Restore this lead to re-enable edits.</small>
                    </div>
                  </div>
                  <Badge color="warning" className="px-3 py-2 fs-6 text-dark fw-bold">ARCHIVED</Badge>
                </div>
              )}

              <Row className="g-4">
                <Col md="6">
                  <Card className="border-0 shadow-sm h-100">
                    <CardBody className="text-center">
                      <div
                        className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center mx-auto mb-3"
                        style={{
                          width: "90px",
                          height: "90px",
                          fontSize: "32px",
                          fontWeight: "700",
                        }}
                      >
                        {leadDetails?.name?.charAt(0) || "L"}
                      </div>

                      <h4 className="mb-1">{leadDetails?.name || "-"}</h4>
                      <div className="mb-3">
                        <Badge
                          color={currentSource.color}
                          pill
                          className="px-3 py-2 fs-6"
                        >
                          <i className={`${currentSource.icon} me-2`} />
                          {currentSource.label}
                        </Badge>
                      </div>
                      <p className="text-muted mb-3">
                         {
                            emailUnlocked ? (
                              <a
                                href={`mailto:${leadDetails?.email}`}
                                className="text-muted"
                                onClick={async()=>{
                                  await createLeadActivityLog(
                                    source,
                                    leadId,
                                    {
                                      action:"email_clicked",
                                    }
                                  );

                                  await fetchLeadActivity(
                                    source,
                                    leadId,
                                    {
                                      page:activityPage,
                                      limit:10,
                                    }
                                  );
                                }}
                              >
                                {leadDetails?.email}
                              </a>
                            ) : (
                              <Button
                                color="link"
                                className="p-0 text-decoration-none"
                                disabled={leadDetails?.isArchived}
                                onClick={async()=>{
                                  await createLeadActivityLog(
                                    source,
                                    leadId,
                                    {
                                      action:"email_viewed",
                                    }
                                  );

                                  setEmailUnlocked(true);

                                  await fetchLeadActivity(
                                    source,
                                    leadId,
                                    {
                                      page:activityPage,
                                      limit:10,
                                    }
                                  );
                                }}
                              >
                                <i className="mdi mdi-lock-outline me-1"></i>
                                {maskEmail(leadDetails?.email)}
                              </Button>
                            )
                          }
                      </p>

                      <div className="d-flex justify-content-center align-items-center gap-3 flex-wrap mb-2">
                        <div className="d-flex align-items-center gap-2 bg-light px-3 py-1 rounded-pill border shadow-sm">
                          <small className="text-muted fw-semibold me-1">Stage:</small>
                          <Badge color="success" pill className="px-3 py-2 fs-6">
                            {leadDetails?.stage || "-"}
                          </Badge>
                          <Button
                            color="primary"
                            size="sm"
                            disabled={leadDetails?.isArchived}
                            className="rounded-circle d-flex align-items-center justify-content-center p-0 shadow-sm"
                            style={{ width: "32px", height: "32px", fontSize: "15px" }}
                            title={leadDetails?.isArchived ? "Archived Lead (Editing Disabled)" : "Edit Stage"}
                            onClick={() => { setSelectedStage(""); setComment(""); setStageModal(true); }}
                          >
                            <i className="mdi mdi-pencil" />
                          </Button>
                        </div>

                        <div className="d-flex align-items-center gap-2 bg-light px-3 py-1 rounded-pill border shadow-sm">
                          <small className="text-muted fw-semibold me-1">Lead Type:</small>
                          <Badge color="warning" pill className="px-3 py-2 fs-6 text-dark">
                            {leadDetails?.remark || "Default"}
                          </Badge>
                          <Button
                            color="warning"
                            size="sm"
                            disabled={leadDetails?.isArchived}
                            className="rounded-circle d-flex align-items-center justify-content-center p-0 shadow-sm text-dark"
                            style={{ width: "32px", height: "32px", fontSize: "16px" }}
                            title={leadDetails?.isArchived ? "Archived Lead (Editing Disabled)" : "Edit Lead Type / Remark"}
                            onClick={() => { setSelectedRemark(leadDetails?.remark || ""); setRemarkModal(true); }}
                          >
                            <i className="mdi mdi-account-cog-outline" />
                          </Button>
                        </div>
                      </div>
                      <hr />

                      <div className="mb-4">
                        <div className="d-flex gap-2 flex-wrap">

                          <Button
                            color="primary"
                            outline
                            onClick={handleCallLead}
                            disabled={contactLoading !== "" || leadDetails?.isArchived}
                          >
                            {
                              contactLoading === "call" ?
                                <Spinner size="sm" />
                                :
                                <>
                                  <i className="mdi mdi-phone me-1" />
                                  Call
                                </>
                            }
                          </Button>

                          <Button
                            color="success"
                            outline
                            onClick={handleWhatsappLead}
                            disabled={contactLoading !== "" || leadDetails?.isArchived}
                          >
                            {
                              contactLoading === "whatsapp" ?
                                <Spinner size="sm" />
                                :
                                <>
                                  <i className="mdi mdi-whatsapp me-1" />
                                  WhatsApp
                                </>
                            }
                          </Button>

                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                <Col md="6">
                  <Row className="g-3">
                    <Col md="6">
                      <Card className="border-0 shadow-sm h-100">
                        <CardBody>
                          <small className="text-muted d-block mb-1">
                            Project
                          </small>
                          <h5 className="mb-0">
                            {leadDetails?.projectId?.projectName || "-"}
                          </h5>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col md="6">
                      <Card className="border-0 shadow-sm h-100">
                        <CardBody>
                          <small className="text-muted d-block mb-1">
                            Assigned To
                          </small>
                          <h5 className="mb-0">
                            {leadDetails?.assignedTo
                              ? `${leadDetails.assignedTo.firstName} ${leadDetails.assignedTo.lastName}`
                              : "-"}
                          </h5>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col md="6">
                      <Card className="border-0 shadow-sm h-100">
                        <CardBody>
                          <small className="text-muted d-block mb-1">
                            Created Time
                          </small>
                          <h6 className="mb-0">
                            {leadDetails?.createdTime
                              ? new Date(leadDetails.createdTime).toLocaleString(
                                  "en-GB",
                                )
                              : "-"}
                          </h6>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col md="6">
                      <Card className="border-0 shadow-sm h-100">
                        <CardBody>
                          <small className="text-muted d-block mb-1">
                            Last Assigned
                          </small>
                          <h6 className="mb-0">
                            {leadDetails?.lastAssignedAt
                              ? new Date(
                                  leadDetails.lastAssignedAt,
                                ).toLocaleString("en-IN",{
                                    timeZone:"Asia/Kolkata",
                                    day:"2-digit",
                                    month:"short",
                                    year:"numeric",
                                    hour:"2-digit",
                                    minute:"2-digit",
                                    hour12:true,
                                  })
                              : "-"}
                          </h6>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col md="12">
                      <Card className="border-0 shadow-sm">
                        <CardBody>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            {
                              !isLeadDataUnlocked &&
                              <Button
                                size="sm"
                                color="primary"
                                onClick={async()=>{
                                  await createLeadActivityLog(
                                    source,leadId, { action:"raw_data_unlocked", }
                                  );
                                  await fetchLeadActivity( source,leadId, { page:activityPage, limit:10, } );
                                  setIsLeadDataUnlocked(true);
                                }}
                              >
                                <i className="mdi mdi-lock-open-outline me-1"/>
                                Unlock Lead Data
                              </Button>
                            }
                            <h5 className="mb-0">Lead Data</h5>
                            <Badge color="info">
                              {leadDetails?.rawData?.length || 0}
                            </Badge>
                          </div>

                          {leadDetails?.rawData?.length ? (
                            <Row
                                className="g-3"
                                style={{
                                  filter:isLeadDataUnlocked ? "none" : "blur(5px)",
                                  pointerEvents:isLeadDataUnlocked ? "auto" : "none",
                                  userSelect:isLeadDataUnlocked ? "auto" : "none",
                                }}
                              >
                              {leadDetails?.rawData?.map((item, index) => {
                                const key =
                                    item?.name ||
                                    item?.field_key ||
                                    `Field ${index + 1}`,
                                  value = item?.values?.[0] || item?.value || "-";
                                return (
                                  <Col md="6" key={index}>
                                    <Card className="border h-100 mb-0">
                                      <CardBody className="py-3">
                                        <small className="text-muted d-block mb-1 text-capitalize">
                                          {key?.replaceAll("_", " ")}
                                        </small>
                                        <div
                                          className="fw-semibold"
                                          style={{ wordBreak: "break-word" }}
                                        >
                                          {value}
                                        </div>
                                      </CardBody>
                                    </Card>
                                  </Col>
                                );
                              })}
                            </Row>
                          ) : (
                            <div className="text-center py-4 text-muted">
                              No Raw Data Found
                            </div>
                          )}
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="g-3 mt-1">
                <Col md="12">
                      <Card className="border-0 shadow-sm">
                        <CardBody>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="mb-0">Activity Timeline</h5>
                            <Badge color="dark">
                              {activityPagination?.total || 0}
                            </Badge>
                          </div>

                          <div style={{ maxHeight: "450px", overflowY: "auto" }}>
                            {activityLoading ? (
                              <div className="text-center py-4">
                                <Spinner size="sm"/>
                              </div>
                            ) : activities?.length ? (
                              activities?.map((history) => ( 
                                <div
                                  key={history?._id}
                                  className="border rounded p-3 mb-3"
                                >
                                  <div className="d-flex justify-content-between align-items-start">
                                    <div>
                                      <div className="fw-bold text-capitalize mb-1">
                                        {history?.action?.replaceAll("_", " ")}
                                      </div>
                                      <div className="text-muted small">
                                          {history?.oldValueDisplay && ( <div> Old : {" "} {history.oldValueDisplay} </div> )}
                                          {history?.newValueDisplay && ( <div> New : {" "} {history.newValueDisplay} </div> )}
                                          {history?.comment && ( <div> Comment : {" "} {history.comment} </div> )}
                                        </div>
                                    </div>
                                    <div className="text-end">
                                      <div className="small fw-semibold">
                                        {history?.changedBy
                                          ? `${history.changedBy.firstName} ${history.changedBy.lastName}`
                                          : "System"}
                                      </div>
                                      <div className="text-muted small">
                                        {new Date(
                                          history?.createdAt,
                                        ).toLocaleString("en-IN",{
                                            timeZone:"Asia/Kolkata",
                                            day:"2-digit",
                                            month:"short",
                                            year:"numeric",
                                            hour:"2-digit",
                                            minute:"2-digit",
                                            hour12:true,
                                        })}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="text-center py-4 text-muted">
                                No Activity Found
                              </div>
                            )}
                          </div>
                          <div className="d-flex justify-content-center align-items-center gap-2 mt-3">
                            <Button
                              size="sm"
                              color="light"
                              disabled={activityPage===1}
                              onClick={()=>
                                setActivityPage(prev=>prev-1)
                              }
                            >
                              <i className="mdi mdi-chevron-left"/>
                            </Button>

                            <Badge color="primary">
                              Page {activityPagination?.page || 1}
                              {" / "}
                              {activityPagination?.totalPages || 1}
                            </Badge>

                            <Button
                              size="sm"
                              color="light"
                              disabled={
                                activityPage>=
                                (activityPagination?.totalPages || 1)
                              }
                              onClick={()=>
                                setActivityPage(prev=>prev+1)
                              }
                            >
                              <i className="mdi mdi-chevron-right"/>
                            </Button>

                          </div>
                        </CardBody>
                      </Card>
                    </Col>
              </Row>
            </>
          )}
        </CardBody>
      </Card>
      <Modal isOpen={stageModal} toggle={()=>setStageModal(false)} centered >

          <ModalHeader toggle={()=>setStageModal(false)} > Change Lead Stage </ModalHeader>

          <ModalBody>

            <h5> {leadDetails?.name} </h5>

            <div className="d-flex align-items-center gap-3 my-3">

              <Badge color="secondary"> {leadDetails?.stage} </Badge>

              <i className="mdi mdi-arrow-right-bold"/>

              <Badge color="success"> { stages.find( s=>s._id===selectedStage )?.name || "Select Stage" } </Badge>

            </div>

            <Select placeholder="Select Stage"
              options={stages.map(s=>({ label:s.name, value:s._id, }))}
              onChange={(e)=> setSelectedStage( e?.value || "" ) }
            />

            <Input
              type="textarea"
              rows="4"
              className="mt-3"
              placeholder="Comment is mandatory..."
              value={comment}
              onChange={(e)=> setComment( e.target.value ) }
            />

          </ModalBody>

          <ModalFooter>
            <Button color="light" onClick={()=> setStageModal(false) } >
              Cancel
            </Button>
            <Button color="primary" disabled={ !selectedStage || !comment.trim() }
              onClick={async()=>{
                await updateLeadStageApi( source,leadId, { stageId:selectedStage, comment, } );
                await fetchLeadDetails(source,leadId);
                await fetchLeadActivity( source,leadId, { page:activityPage, limit:10, } );
                setStageModal(false);
              }}
            >
              Update Stage
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={remarkModal} toggle={() => setRemarkModal(false)} centered>
          <ModalHeader toggle={() => setRemarkModal(false)}>Update Lead Type / Remark</ModalHeader>
          <ModalBody>
            <h5 className="mb-2">{leadDetails?.name}</h5>
            <p className="text-muted small mb-3">
              Current Lead Type / Remark: <strong>{leadDetails?.remark || "None"}</strong>
            </p>

            <label className="form-label fw-semibold">Select or Enter Lead Type</label>
            <CreatableSelect
              placeholder="Select or type custom remark (Broker, Seller, Property RM, Buyer, etc.)..."
              isClearable
              options={REMARK_OPTIONS}
              value={selectedRemark ? { label: selectedRemark, value: selectedRemark } : null}
              onChange={(opt) => setSelectedRemark(opt ? opt.value : "")}
            />
          </ModalBody>
          <ModalFooter>
            <Button color="light" onClick={() => setRemarkModal(false)}>
              Cancel
            </Button>
            <Button
              color="primary"
              disabled={updatingRemark}
              onClick={async () => {
                try {
                  setUpdatingRemark(true);
                  await updateLeadRemark(source, leadId, selectedRemark);
                  await fetchLeadActivity(source, leadId, { page: activityPage, limit: 10 });
                  setRemarkModal(false);
                } finally {
                  setUpdatingRemark(false);
                }
              }}
            >
              {updatingRemark ? <Spinner size="sm" /> : "Update Remark"}
            </Button>
          </ModalFooter>
        </Modal>
    </div>
  );
};

export default LeadDetails;
